import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

interface TripListPricingContextValue {
  luxPlusEnabled: boolean
  onLuxPlusToggle: () => void
}

const TripListPricingContext = createContext<TripListPricingContextValue | undefined>(undefined)

export function TripListPricingProvider({ children }: { children: ReactNode }) {
  const [luxPlusEnabled, setLuxPlusEnabled] = useState(true)
  const onLuxPlusToggle = useCallback(() => {
    setLuxPlusEnabled(prev => !prev)
  }, [])

  const value = useMemo(() => ({
    luxPlusEnabled,
    onLuxPlusToggle,
  }), [luxPlusEnabled, onLuxPlusToggle])

  return (
    <TripListPricingContext.Provider value={value}>
      {children}
    </TripListPricingContext.Provider>
  )
}

export function useTripListPricingContext(): TripListPricingContextValue {
  const context = useContext(TripListPricingContext)
  if (!context) throw new Error('useTripListPricingContext must be used within TripListPricingProvider')
  return context
}
